import type { ContentHref } from '@generalTypes/apiTypes';
import { getAllDescendantHrefs } from '@newStore/documentUI/documentUIHelpers';
import { createTypedSelector, mapRelationsToRelationsToAndFrom } from '@newStore/genericHelpers';
import { sectionCurrVakkenEnLeerplannen } from '@store/constants/constants';

export const selectHighlightedThemesOptionsSet = createTypedSelector(
  [(state, href: ContentHref) => state.referenceFrames[href]],
  (referenceFrame) => {
    if (!referenceFrame?.relations) {
      return new Set();
    }
    const relationsMap = mapRelationsToRelationsToAndFrom(referenceFrame.relations);
    const oldCurrHrefs = getAllDescendantHrefs(
      relationsMap?.to,
      `/content/${sectionCurrVakkenEnLeerplannen}` as ContentHref,
    );
    return new Set(oldCurrHrefs);
  },
);
